import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=47cb7f38&scoped=true&"
import script from "./SuccessPage.vue?vue&type=script&lang=js&"
export * from "./SuccessPage.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=47cb7f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb7f38",
  null
  
)

export default component.exports